import styled from 'styled-components';

const UserName = styled.p`
    margin: 0 10px;
    font-weight: 400;
    font-size: 16px;
    color: #4A5568;
`

export default UserName;